import { render, staticRenderFns } from "./SubRatingForm.vue?vue&type=template&id=613a4bca"
import script from "./SubRatingForm.vue?vue&type=script&lang=js"
export * from "./SubRatingForm.vue?vue&type=script&lang=js"
import style0 from "./SubRatingForm.vue?vue&type=style&index=0&id=613a4bca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports